<ng-container *ngIf="rolesRegistrationsList.length">
    <label class="input-label mt-2">{{'Role registrations' | translate}}</label>
    <div class="table-items">
        <div class="item">
            <div class="row cursor-row" (click)="all ? unselectAll() : selectAll()">
                <div class="col-auto align-items-center justify-content-start">
                    <span class="{{all ? 'fa-toggle-large-on toggle-primary' : 'fa-toggle-large-on fa-flip-horizontal toggle-disabled'}} fas toggle__icon"></span>
                </div>
                <div class="col pl-0 align-items-center justify-content-start">{{'All registrations' | translate}}</div>
            </div>
        </div>
        <div class="item" *ngFor="let reg of rolesRegistrationsList; let i = index;">
            <div class="row" [class.cursor-row]="!reg.locked" [class.opacity-50]="reg.locked" (click)="registrationToggle(reg)">
                <div class="col-auto align-items-center justify-content-start">
                    <span class="{{reg.checked ? 'fa-toggle-large-on toggle-primary' : 'fa-toggle-large-on fa-flip-horizontal toggle-disabled'}} fas toggle__icon"></span>
                </div>
                <div class="col pl-0 align-items-center justify-content-start d-flex align-items-center">
                    <span>{{ reg.name }}</span>
                    <i *ngIf="reg.locked" class="fas fa-lock ml-2 text-muted" tooltip="{{'Cannot unselect - viewing this role' | translate}}"></i>
                </div>
            </div>
        </div>
    </div>
</ng-container>
